import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Bullets = styled.ul.withConfig({
  displayName: "Bullets",
  componentId: "sc-1l4ak5a-0"
})(["margin:20px 10px;"]);
export var BulletsItem = styled.li.withConfig({
  displayName: "Bullets__BulletsItem",
  componentId: "sc-1l4ak5a-1"
})(["margin-left:30px;list-style-type:disc;", ";"], getFont('-1', 'compact'));